<app-rating-stars [itemId]="item.id" [rating]="item.rating" (ratingClick)="onClick($event)" [enabled]="enabled"></app-rating-stars>
